import { Image } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';
import { SocialButtonCommonStyles } from 'src/common/styles';
export const StyledTitle = styled.h3<{
  isSmall?: boolean;
  leftAligned?: boolean;
}>`
  font-weight: ${({
  theme
}) => theme.fonts.weight.semiBold};
  margin-top: 2.5rem;
  margin-bottom: 0.56rem;

  font-size: ${({
  theme
}) => theme.fonts.sizes.default};
  text-align: ${({
  leftAligned
}) => leftAligned ? 'left' : 'center'};
`;
export const StyledFormTitle = styled.h5`
  font-weight: ${({
  theme
}) => theme.fonts.weight.semiBold};
  text-align: left;
  margin-bottom: -0.1rem;
  font-size: ${({
  theme
}) => theme.fonts.sizes.default};
`;
export const StyledBadgeImage = styled(Image)`
  width: 100%;
  height: auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-radius: 4px;
`;
export const StyledShareSocialButtonsWrapper = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;
export const StyledSocialButton = styled.a`
  ${SocialButtonCommonStyles};
  height: 4rem;
  border-radius: ${({
  theme
}) => theme.radius.huge};
  padding: 0.9rem;

  svg {
    width: 2.4rem;
    height: 2.4rem;
    margin: 0;

    path {
      fill: ${({
  theme
}) => theme.colors.white};
    }
  }
`;